var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlankuploadimage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.404297,
    y: 0.853516,
    width: 72,
    height: 72,
    rx: 8,
    fill: "#E0E0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4808 30.7297C30.2169 30.7297 33.246 27.6232 33.246 23.7916C33.246 19.9596 30.2169 16.8535 26.4808 16.8535C22.7442 16.8535 19.7151 19.9596 19.7151 23.7916C19.7151 27.6232 22.7442 30.7297 26.4808 30.7297ZM57.3348 36.6524L63.4043 42.877C63.2106 45.8646 62.9263 48.8452 62.5517 51.8146L52.5508 41.5582C52.2368 41.236 51.8639 40.9805 51.4535 40.8061C51.0431 40.6317 50.6033 40.542 50.1591 40.542C49.7148 40.542 49.275 40.6317 48.8646 40.8061C48.4542 40.9805 48.0813 41.236 47.7673 41.5582L40.4215 49.0917C36.4586 53.1558 30.0334 53.1558 26.07 49.0917L25.4899 48.4963C24.8554 47.8459 23.9951 47.4806 23.098 47.4806C22.2009 47.4806 21.3405 47.8459 20.706 48.4963L12.557 56.8535C11.613 55.5409 10.9816 53.9655 10.7572 52.2251C10.6351 51.2757 10.5163 50.2823 10.4043 49.2492L15.9224 43.5905C19.8853 39.5263 26.3106 39.5263 30.2735 43.5905L30.854 44.1855C31.1681 44.5076 31.5409 44.7632 31.9513 44.9376C32.3617 45.1119 32.8016 45.2017 33.2458 45.2017C33.69 45.2017 34.1299 45.1119 34.5402 44.9376C34.9506 44.7632 35.3235 44.5076 35.6376 44.1855L42.9833 36.6524C46.9462 32.5878 53.3715 32.5883 57.3348 36.6524Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankuploadimage);
export default __webpack_public_path__ + "static/media/blankuploadimage.98ac615a9b00db78b64c76f69ba12002.svg";
export { ForwardRef as ReactComponent };